(function () {
  function initAll() {
    document.querySelectorAll('product-info[data-box-size-product="true"]').forEach(function (productInfo) {
      if (productInfo.__boxSizeInitialized) return;
      productInfo.__boxSizeInitialized = true;

      try {
        new BoxSizeVariantController(productInfo);
      } catch (e) {
        console.error('BoxSizeVariantController init failed', e);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);

  // Dawn replaces variant-selects HTML when options change. Watch for any
  // new variant-selects inside Box Size product-info elements and
  // initialize the controller on them as well so the UI doesn't disappear.
  function startGlobalVariantObserver() {
    if (!window.MutationObserver) return;

    try {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var mutation = mutations[i];
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            var node = mutation.addedNodes[j];
            if (!(node instanceof Element)) continue;

            var candidates = [];
            if (node.matches && node.matches('variant-selects')) {
              candidates.push(node);
            }
            candidates = candidates.concat(Array.prototype.slice.call(node.querySelectorAll ? node.querySelectorAll('variant-selects') : []));

            candidates.forEach(function (vs) {
              var productInfo = vs.closest('product-info[data-box-size-product="true"]');
              if (!productInfo) return;
              // Allow re-init after HTML replacement
              productInfo.__boxSizeInitialized = false;
              initAll();
            });
          }
        }
      });

      observer.observe(document.documentElement || document.body, {
        childList: true,
        subtree: true,
      });
    } catch (e) {
      console.warn('BoxSizeVariantController: unable to start global variant observer', e);
    }
  }

  document.addEventListener('DOMContentLoaded', startGlobalVariantObserver);

  function BoxSizeVariantController(productInfo) {
    this.productInfo = productInfo;
    this.productId = productInfo.dataset.productId;
    this.variantSelects = productInfo.querySelector('variant-selects');
    if (!this.variantSelects) return;

    // Force-show native Dawn variant selector for Box Size products
    // and keep it visible even if third-party scripts try to hide it.
    this.forceShowVariantSelects();
    this.startVisibilityObserver();

    var productJsonScript = document.getElementById('BoxSizeProduct-' + this.productId);
    if (!productJsonScript) {
      console.warn('BoxSize product JSON script not found for product', this.productId);
      return;
    }

    try {
      this.productData = JSON.parse(productJsonScript.textContent);
    } catch (e) {
      console.error('Failed to parse BoxSize product JSON', e);
      return;
    }

    this.options = this.productData.options || [];
    this.sizeIndex = findIndexByName(this.options, ['select size', 'size']);
    this.productsIndex = findIndexByName(this.options, ['products', 'set of']);
    this.colorIndex = findIndexByName(this.options, ['color', 'colour']);

    if (this.sizeIndex === -1 || this.productsIndex === -1 || this.colorIndex === -1) {
      console.warn('BoxSizeVariantController: expected 3 options (size/products/color), got', this.options);
      return;
    }

    this.buildComboMap();
    this.optionBlocks = Array.prototype.slice.call(
      this.variantSelects.querySelectorAll('.product-form__input')
    );

    if (this.optionBlocks.length < 3) return;

    this.isSyncing = false;

    this.onChange = this.handleChange.bind(this);
    this.variantSelects.addEventListener('change', this.onChange);

    this.syncFromDom(true);
  }

  BoxSizeVariantController.prototype.buildComboMap = function () {
    var variants = this.productData.variants || [];
    var combos = {};

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var opts = v.options || [];
      if (opts.length < 3) continue;

      var size = opts[this.sizeIndex];
      var product = opts[this.productsIndex];
      var color = opts[this.colorIndex];

      if (!combos[size]) {
        combos[size] = { products: {}, hasAvailable: false };
      }
      var sizeEntry = combos[size];

      if (!sizeEntry.products[product]) {
        sizeEntry.products[product] = { colors: {}, hasAny: false, hasAvailable: false };
      }
      var prodEntry = sizeEntry.products[product];

      if (!prodEntry.colors[color]) {
        prodEntry.colors[color] = { hasAny: false, hasAvailable: false };
      }
      var colorEntry = prodEntry.colors[color];

      sizeEntry.hasAvailable = sizeEntry.hasAvailable || v.available;
      prodEntry.hasAny = true;
      prodEntry.hasAvailable = prodEntry.hasAvailable || v.available;
      colorEntry.hasAny = true;
      colorEntry.hasAvailable = colorEntry.hasAvailable || v.available;
    }

    this.combos = combos;
  };

  BoxSizeVariantController.prototype.forceShowVariantSelects = function () {
    if (!this.variantSelects) return;
    try {
      this.variantSelects.style.setProperty('display', 'block', 'important');
      this.variantSelects.removeAttribute('hidden');
      this.variantSelects.style.removeProperty('visibility');
    } catch (e) {
      console.warn('BoxSizeVariantController: unable to force-show variant-selects', e);
    }
  };

  BoxSizeVariantController.prototype.startVisibilityObserver = function () {
    if (!window.MutationObserver || !this.variantSelects) return;
    var self = this;
    try {
      this.visibilityObserver = new MutationObserver(function () {
        self.forceShowVariantSelects();
      });
      this.visibilityObserver.observe(this.variantSelects, {
        attributes: true,
        attributeFilter: ['style', 'class', 'hidden'],
      });
    } catch (e) {
      console.warn('BoxSizeVariantController: unable to observe variant-selects visibility', e);
    }
  };

  BoxSizeVariantController.prototype.handleChange = function () {
    if (this.isSyncing) return;
    this.syncFromDom(false);
  };

  BoxSizeVariantController.prototype.readState = function () {
    var values = [];
    for (var i = 0; i < this.optionBlocks.length; i++) {
      values.push(getCurrentValueForBlock(this.optionBlocks[i]));
    }

    return {
      size: values[this.sizeIndex] || null,
      product: values[this.productsIndex] || null,
      color: values[this.colorIndex] || null,
    };
  };

  BoxSizeVariantController.prototype.syncFromDom = function (initial) {
    var state = this.readState();
    var combo = this.getBestCombo(state, initial);
    if (!combo) return;

    this.isSyncing = true;

    try {
      this.ensureSelection(combo);
      this.updateProductOptions(combo.size);
      this.updateColorOptions(combo.size, combo.product);
    } finally {
      this.isSyncing = false;
    }
  };

  BoxSizeVariantController.prototype.getBestCombo = function (state, initial) {
    var size = state.size;
    var product = state.product;
    var color = state.color;

    if (size && product && color && this.isAvailableCombo(size, product, color)) {
      return { size: size, product: product, color: color };
    }

    var combos = this.combos;
    var sizeKeys = Object.keys(combos);
    if (sizeKeys.length === 0) return null;

    for (var s = 0; s < sizeKeys.length; s++) {
      var sizeKey = sizeKeys[s];
      var sizeEntry = combos[sizeKey];
      if (!sizeEntry || !sizeEntry.hasAvailable) continue;

      var productKeys = Object.keys(sizeEntry.products);
      for (var p = 0; p < productKeys.length; p++) {
        var prodKey = productKeys[p];
        var prodEntry = sizeEntry.products[prodKey];
        if (!prodEntry || !prodEntry.hasAvailable) continue;

        var colorKeys = Object.keys(prodEntry.colors);
        for (var c = 0; c < colorKeys.length; c++) {
          var colorKey = colorKeys[c];
          var colorEntry = prodEntry.colors[colorKey];
          if (!colorEntry || !colorEntry.hasAvailable) continue;

          return { size: sizeKey, product: prodKey, color: colorKey };
        }
      }
    }

    return null;
  };

  BoxSizeVariantController.prototype.isAvailableCombo = function (size, product, color) {
    var sizeEntry = this.combos[size];
    if (!sizeEntry) return false;
    var prodEntry = sizeEntry.products[product];
    if (!prodEntry) return false;
    var colorEntry = prodEntry.colors[color];
    if (!colorEntry) return false;
    return !!colorEntry.hasAvailable;
  };

  BoxSizeVariantController.prototype.ensureSelection = function (combo) {
    var sizeBlock = this.optionBlocks[this.sizeIndex];
    var productBlock = this.optionBlocks[this.productsIndex];
    var colorBlock = this.optionBlocks[this.colorIndex];

    setValueForBlock(sizeBlock, combo.size);
    setValueForBlock(productBlock, combo.product);
    setValueForBlock(colorBlock, combo.color);
  };

  BoxSizeVariantController.prototype.updateProductOptions = function (size) {
    var sizeEntry = this.combos[size];
    var productBlock = this.optionBlocks[this.productsIndex];
    if (!sizeEntry || !productBlock) return;

    var productKeys = Object.keys(sizeEntry.products);
    updateBlockOptions(productBlock, function (value) {
      var entry = sizeEntry.products[value];
      if (!entry || !entry.hasAny) {
        return { visible: false, disabled: true };
      }
      return { visible: true, disabled: !entry.hasAvailable };
    });
  };

  BoxSizeVariantController.prototype.updateColorOptions = function (size, product) {
    var sizeEntry = this.combos[size];
    var colorBlock = this.optionBlocks[this.colorIndex];
    if (!sizeEntry || !colorBlock) return;

    var prodEntry = sizeEntry.products[product];
    if (!prodEntry) {
      updateBlockOptions(colorBlock, function () {
        return { visible: false, disabled: true };
      });
      return;
    }

    updateBlockOptions(colorBlock, function (value) {
      var entry = prodEntry.colors[value];
      if (!entry || !entry.hasAny) {
        return { visible: false, disabled: true };
      }
      return { visible: true, disabled: !entry.hasAvailable };
    });
  };

  function getCurrentValueForBlock(block) {
    var select = block.querySelector('select');
    if (select) return select.value || null;

    var checked = block.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value || null;

    return null;
  }

  function setValueForBlock(block, value) {
    if (!block) return;

    var select = block.querySelector('select');
    if (select) {
      if (select.value === value) return;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    var inputs = block.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];
      if (input.value === value) {
        if (input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }

  function updateBlockOptions(block, getStatus) {
    var select = block.querySelector('select');

    if (select) {
      var options = Array.prototype.slice.call(select.options);
      options.forEach(function (opt) {
        var value = opt.value;
        var status = getStatus(value);
        opt.hidden = !status.visible;
        opt.disabled = !!status.disabled;
      });
      return;
    }

    var inputs = Array.prototype.slice.call(block.querySelectorAll('input[type="radio"]'));
    inputs.forEach(function (input) {
      var value = input.value;
      var status = getStatus(value);
      var wrapperLabel = block.querySelector('label[for="' + input.id + '"]') || input.closest('label');

      if (status.visible === false) {
        if (wrapperLabel) wrapperLabel.style.display = 'none';
        input.disabled = true;
        input.classList.add('disabled');
      } else {
        if (wrapperLabel) wrapperLabel.style.display = '';
        input.disabled = !!status.disabled;
        if (status.disabled) {
          input.classList.add('disabled');
        } else {
          input.classList.remove('disabled');
        }
      }
    });
  }

  function findIndexByName(options, names) {
    var lowerNames = names.map(function (n) {
      return n.toLowerCase();
    });

    for (var i = 0; i < options.length; i++) {
      var name = String(options[i]).toLowerCase();
      for (var j = 0; j < lowerNames.length; j++) {
        if (name.indexOf(lowerNames[j]) !== -1) return i;
      }
    }
    return -1;
  }
})();
